import MercurXIcons from '../MercurXIcons/MercurXIcons';
import './MercurXSortableHeader.scss';

function MercurXSortableHeader({
  label,
  isActive,
  isAscending,
  onClick,
}) {
  return (
    <button
      type="button"
      className={`mercurx-sortable-header${isActive ? ' is-active' : ''}`}
      onClick={onClick}
    >
      <span>{label}</span>
      <span className="mercurx-sortable-header-icon" aria-hidden="true">
        <MercurXIcons
          name={isActive && isAscending ? 'BiSortUp' : 'BiSortDown'}
          size={15}
        />
      </span>
    </button>
  );
}

export default MercurXSortableHeader;
